'use client';

import { Modal } from 'react-bootstrap';
import { X } from 'react-feather';
import classes from './StripeConnectOnboardingModal.module.css';
import { AlertTriangle } from 'react-feather';
import DarkGreenButton from '@/components/UI/Buttons/DarkGreenButton';
import { FaStripe } from 'react-icons/fa';
const StripeConnectOnboardingModal = (props) => {
	const {
		show,
		SET_HIDE_MODAL,
		startStripeOnbaording,
		loadingStripeOnboarding,
	} = props;

	return (
		<Modal show={show} onHide={SET_HIDE_MODAL}>
			<section className={classes.modalHeader}>
				<section className={classes.col}>
					<h1 className={classes.modalTitle}>
						<AlertTriangle
							style={{ marginBottom: '0.5rem', marginRight: '0.5rem' }}
						/>
						Complete your onboarding
					</h1>
				</section>
				<X
					className={classes.modalClose}
					strokeWidth={1}
					onClick={SET_HIDE_MODAL}
				/>
			</section>
			<section className={classes.modalBody1}>
				<p style={{ textAlign: 'center' }}>
					Kashew partners with <FaStripe size={30} /> to release payouts to all
					sellers. Please complete your onboarding on Stripe Connect to receive
					payouts.
				</p>
				<div className={classes.content}>
					<h6>Why do I need to complete onboarding?</h6>
					<p>
						Stripe and financial regulations require identity and business
						verification (KYC) before sellers can receive payouts. This helps
						prevent fraud, money laundering, and ensures secure payments for
						both you and your customers. It typically takes just a few minutes,
						and we&apos;ll guide you step-by-step.
					</p>

					<p>
						You can read more about it{' '}
						<a
							href="https://support.stripe.com/questions/know-your-customer-obligations"
							target="_blank"
							rel="noreferrer"
						>
							here
						</a>
					</p>
					{/* <h6>What do I need?</h6>
					<ul>
						<li>Identification (e.g. passport, national ID)</li>
						<li>Proof of address</li>
						<li>Business details (company registration, tax ID)</li>
					</ul>

					<p>
						Stripe will request only what&apos;s needed for your business type.
					</p> */}
				</div>
			</section>

			<Modal.Footer
				style={{ justifyContent: 'center', padding: '1rem 1.5rem' }}
			>
				<DarkGreenButton
					onClick={startStripeOnbaording}
					disabled={loadingStripeOnboarding}
				>
					{loadingStripeOnboarding ? 'Loading...' : <>Let&apos;s do it!</>}
				</DarkGreenButton>
			</Modal.Footer>
		</Modal>
	);
};

export default StripeConnectOnboardingModal;
